module.exports = __webpack_public_path__ + "img/13h-villages.73c3d1ef.jpg";